import axios from "axios";
import Vue from "vue";
// axios.defaults.withCredentials = true
export default new (function httpClients() {
  axios.create({
    baseURL: "http://www.newlegend.com.au/",
    timeout: 3000,
    headers: {
      "Content-Type": "application/json; charset=utf-8",
    },
  });
  this.host = "/api";

  this.protocol = {
    message_add: this.host + "/VisApi/message_add", // 联系我们
    review_add1: this.host + "/VisApi/review_add1", // 中小学留学评估
    review_add2: this.host + "/VisApi/review_add2", // 大学留学评估
    review_add3: this.host + "/VisApi/review_add3", // eio评估
    review_add4: this.host + "/VisApi/review_add4", // 雇主担保评估
    review_add5: this.host + "/VisApi/review_add5", // 配偶签证评估
    complaint_add: this.host + "/VisApi/complaint_add", // 投诉建议
    complaint_list: this.host + "/VisApi/complaint_list", // 投诉建议列表
    video_nav_list: this.host + "/VisApi/nav_list", // 视频分类列表
    video_list: this.host + "/VisApi/video_list", // 视频列表
    message_add: this.host + "/VisApi/message_add", // 留言板
    news_list: this.host + "/H5Api/news_list", // 首页新闻
    banner_list: this.host + "/H5Api/banner_list", // 首页轮播图
    news_list: this.host + "/H5Api/news_list", // 新闻资讯
    news_list_view: this.host + "/VisApi/news_list", // 新闻列表
    nav_list: this.host + "/H5Api/nav_list", // 新闻分类
    nav_bottom_list: this.host + "/H5Api/nav_bottom_list", // 底部导航
    nav_list_view: this.host + "/H5Api/nav_list_view", // 新闻分类
    job_list: this.host + "/VisApi/job_list", // 招聘列表 

  };

  this.get_token_list = function (symbols) {
    let wallets = {};
    return this.get_assets()
      .then((result) => {
        if (result.code === 200) {
          for (let i = 0; i < result.data.length; ++i) {
            let item = result.data[i];
            wallets[item.symbol] = item;
          }
          return this.get_rate({
            orgCoin: symbols,
            targetCoin: "GBP",
          });
        }
        return result;
      })
      .then((result) => {
        if (result.code === 200) {
          let rates = {};
          for (let i = 0; i < result.data.length; ++i) {
            let item = result.data[i];
            rates[item.orgCoin] = item;
          }
          return {
            code: 200,
            wallets,
            rates,
          };
        }
        return result;
      });
  };

  this.to_withdraw = function (params) {
    params.fromId = Vue.prototype.$config.getUser().uuid;
    return this.post(this.protocol.to_withdraw, params);
  };

  function query(key, data) {
    if (Array.isArray(data)) {
      let r = [];
      data.forEach((str) => {
        if (str) {
          r.push(encodeURIComponent(key) + "[]=" + encodeURIComponent(str));
        }
      });
      return r.join("&");
    }
    return encodeURIComponent(key) + "=" + encodeURIComponent(data);
  }

  function queryString(params) {
    return (
      "?" +
      Object.keys(params)
        .map(function (key) {
          return query(key, params[key]);
        })
        .join("&")
    );
  }

  function noqueryString(params) {
    return Object.values(params).join("/");
  }

  this.sendGet = function (url) {
    return axios({
      url: url,
      type: "GET",
      dataType: "json",
      // crossDomain: true,
      // baseURL: "https://qcfa.chinasay.cn/",
      // xhrFields: {
      //   withCredentials: true
      // },
      contentType: "multipart/json",
    }).then((response) => {
      return response.data;
    });
  };
  this.getHeaders = function () {
    let sign = Vue.prototype.$config.getSignature();
    if (sign) {
      return {
        "access-key": sign.access_key,
        nonce: sign.nonce,
        signature: sign.signature,
        timestamp: sign.timestamp,
      };
    } else {
      return {};
    }
  };
  this.sendPost = function (url, options) {
    return axios({
      method: "POST",
      url: url,
      // crossDomain: true,
      // xhrFields: {
      //   withCredentials: true
      // },
      data: options,
      contentType: "application/json",
    })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err;
      });
  };
  this.formData = function (params) {
    if (typeof params === "object") {
      let formData = new FormData();
      let postDataInstances = [ArrayBuffer, Blob, Document, FormData, File];
      for (let key in params) {
        if (
          params[key] &&
          typeof params[key] === "object" &&
          postDataInstances.indexOf(params[key].constructor) === -1
        ) {
          formData.append(key, JSON.stringify(params[key]));
        } else {
          formData.append(key, params[key]);
        }
      }
      return formData;
    }
    return params;
  };
  this.get = function (url, params) {
    if (typeof params !== "object") {
      return this.sendGet(url);
    } else {
      if (params.mode === "noquery") {
        delete params.mode;
        return this.sendGet(url + noqueryString(params));
      } else {
        return this.sendGet(url + queryString(params));
      }
    }
  };
  this.post = function (url, params) {
    return this.sendPost(url, params);
  };


  this.message_add = function (params) {
    // 联系我们
    return this.post(this.protocol.message_add, params);
  };
  this.review_add1 = function (params) {
    // 中小学评估
    return this.post(this.protocol.review_add1, params);
  };
  this.review_add2 = function (params) {
    // 在线自评
    return this.post(this.protocol.review_add2, params);
  };
  this.review_add3 = function (params) {
    // 在线自评
    return this.post(this.protocol.review_add3, params);
  };
  this.review_add4 = function (params) {
    // 在线自评
    return this.post(this.protocol.review_add4, params);
  };
  this.review_add5 = function (params) {
    // 在线自评
    return this.post(this.protocol.review_add5, params);
  };
  this.complaint_add = function (params) {
    // 投诉建议
    return this.post(this.protocol.complaint_add, params);
  };
  this.complaint_list = function (params) {
    // 投诉建议列表
    return this.get(this.protocol.complaint_list, params);
  };
  
  this.video_nav_list = function (params) {
    // 视频分类列表
    return this.get(this.protocol.video_nav_list, params);
  };
  this.video_list = function (params) {
    // 视频列表
    return this.get(this.protocol.video_list, params);
  };
  this.message_add = function (params) {
    // 留言板
    return this.post(this.protocol.message_add, params);
  };
  this.news_list = function (params) {
    // 首页新闻
    return this.get(this.protocol.news_list, params);
  };
  this.banner_list = function (params) {
    // 首页轮播图
    return this.get(this.protocol.banner_list, params);
  };
  this.news_list_view = function (params) {
    // 新闻资讯
    return this.get(this.protocol.news_list_view, params);
  };
  this.nav_list = function (params) {
    // 新闻分类
    return this.get(this.protocol.nav_list, params);
  };
  
  this.nav_bottom_list = function (params) {
    // 底部导航
    return this.get(this.protocol.nav_bottom_list, params);
  };
  this.nav_list_view = function (params) {
    // 新闻分类
    return this.get(this.protocol.nav_list_view, params);
  }
  this.job_list = function (params) {
    // 招聘列表
    return this.get(this.protocol.job_list, params);
  }
  
})();



// WEBPACK FOOTER //
// ./src/utils/http.js